module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_9-71a2fc00b95cead792e06f4ca69e52f4.jpg";